import access from '@/api/access';
import admin from '@/api/admin'
import common from '@/api/common'
import { TRUE } from 'sass';

export default{
    install(Vue){
        Vue.config.globalProperties.$setLoginNeed = function(){
            let isValue = true;

            if(this.$store.state.userInfo){
            var checkIdno = this.$store.state.userInfo.hasOwnProperty('idno'); 
            if(checkIdno && this.$store.state.userInfo.idno){
                if(this.$store.state.userInfo.idno.length === 8 ){
                    isValue = false;
                }
            }
          }
          this.$store.commit('setIsLoginNeed',isValue)
        },
        Vue.config.globalProperties.$isLogin = function(){
            let isLogin = false;

            if(this.$store.state.userInfo){
            var checkIdno = this.$store.state.userInfo.hasOwnProperty('idno'); 
            if(checkIdno && this.$store.state.userInfo.idno){
                if(this.$store.state.userInfo.idno.length === 8 ){
                    isLogin = true;
                }
            }
          }
          return isLogin
        },
        Vue.config.globalProperties.$autoLogin = async function(suid, ssid){
            let ret = await access.login(this.$store.state.provider.id,undefined,undefined,true, suid, ssid, true)
                .then((result) =>{
                    if(result){
                        if(result.success === 'Y'){

                            this.$store.commit('setUserInfo',result.user)
                        }
                        return true;
                    }else{
                        return false;
                    }
                });
            return ret;
        },
        Vue.config.globalProperties.$setProvider = async function(urll){
            let url = window.location.hostname
            // console.log("11:" + urll)
            // if(!urll){
            //     console.log("TEST:" + url)
            //     urll = url
            // }
            // console.log("TEST2:" + urll)
            let providerData = await admin.selectProviderByUrl(url, urll)
            .then((result) => {
                if(result.data){
                    return result.data
                }
            })
            .catch((error) => {
                console.log(error);
            });
            if(!providerData){
                return false     
            }
            if(!providerData.pvifpvid){
                return false
            } 
            sessionStorage.setItem('hosp', urll)
            let provider ={
                id: providerData.pvifpvid,
                hpno: providerData.pvifhpno,
                name: providerData.pvifname,
                teln: providerData.pviftele,
                addr: providerData.pvifaddr,
                faxx: providerData.pviffaxx,
                cprt: providerData.pvifcprt,
                chif: providerData.pvifchif,
                hurl: providerData.pvifhurl,
                iurl: providerData.pvifiurl,
                shar: providerData.pvifshar,
                env: providerData.env,
                ngit:providerData.pvifngit
            }
            this.$store.commit('setProvider',provider)
            return true
        },
        Vue.config.globalProperties.$checkTokn = async function(pvid, idno, tokn){
            let retVal = await common.sys0102a_g(pvid, idno, tokn)
            .then((result) => {
                if(result.data){
                    return result.data
                }
            })
            .catch((error) => {
                console.log(error);
            });
            if(!retVal){
                return false     
            }
            if(!retVal.succ){
                return false
            } 
            if(retVal.succ === 'Y'){
                return true
            }else{
                return false;
            }
        },
        Vue.config.globalProperties.$getTheme = async function(){
            if(this.$store.state.theme.isLoad === false){
                await admin.getInitAdminData(this.$store.state.provider.id, 'Theme')
                .then((result) =>{
                    if(result){
                        let theme = { isLoad: false, color: "", font: "" }
                        if(result.data){
                            if(result.data.Data){
                                let dataCnt = 0;
                                for(var item of result.data.Data){
                                    if(item.cbsditem === 'THEME'){
                                        dataCnt ++
                                        theme.color = item.cbsdcode
                                    }else if(item.cbsditem === 'FONT'){
                                        dataCnt ++
                                        theme.font = item.cbsdcode
                                    }
                                }
                                if(dataCnt > 1){
                                    theme.isLoad = true
                                    this.$store.commit('setTheme',theme)
                                }else{
                                    theme.isLoad = false
                                }
                            }
                        }
                    }
                });
            }
            return this.$store.state.theme;
        }
    }
}